<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div v-if="modules.length==1">
            <div class="page_block" v-if="modules[0].no_chart!=true">
                <h3>{{modules[0].chart.title}}
                    <ChartTrans v-if="modules[0].chart.summary && modules[0].chart.type!='mixin'" :fields="modules[0].fields" :chart="modules[0].chart" :datas="datas[0]" v-model="modules[0].trans_chart"  style="float:right"/>
                    <!-- <Mark :id="$route.query.id" :chart="modules[0].chart" style="float:right"/> -->
                </h3>
                <div class="page_block_content">
                    <!-- <Chart :datas="datas[0]" :fields="modules[0].fields" :conf="modules[0].chart" :height="400" :marks="marks"/> -->
                    <Chart :marks="nMarks[0]" :datas="modules[0].trans_chart?modules[0].trans_chart.data:datas[0]" :fields="modules[0].fields" :conf="modules[0].trans_chart?modules[0].trans_chart.config:modules[0].chart" :height="400"/>
                </div>
            </div>
            <div class="page_block" v-if="modules[0].no_table!=true">
                <h3>{{modules[0].name}}
                    <a-button-group style="float:right; margin:0 0 0 10px" >
                        <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1'" :table="isMark(datas[0], modules[0].fields)" :id="$route.query.id" /> -->
                        <a-button @click="lockHeader(0)" :type="locks.indexOf(0)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(0)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                        <a-button @click="exportToExcel(0)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                        <a-button @click="copy(0)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                    </a-button-group>
                </h3>
                <div class="page-block-info" v-html="getInfo(modules[0].infos, undefined, datas[0])" v-if="modules[0].infos && modules[0].infos.text"></div>
                <div class="page_block_content">
                    <DataTable v-if="modules[0].no_table!=true" :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" 
                    :datas="datas[0]" ref="datatable_0"  :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[0].xlen"
                    :small="modules[0].table && modules[0].table.size === 'small'" :topscroll="config.topscroll" :show_index="modules[0].show_index"/>
                </div>
            </div>
        </div>
        <div v-if="modules.length>1">
            <div class="page_block">
                <a-tabs v-model="current">
                    <a-tab-pane :tab="m.name" v-for="(m, index) in modules" :key="index">
                        <div class="page_block_content" v-if="current===index">
                            <h3 v-if="modules[index].no_chart!=true">{{modules[index].chart.title}}
                                <!-- <Mark v-if="$route.query.proj='mn1'" :id="$route.query.id" :table="isMark(datas[0], modules[0].fields)" :chart="modules[index].chart" style="float:right; margin:-1px 0 0 10px;"/> -->
                                <ChartTrans v-if="modules[index].chart.summary && modules[index].chart.type!='mixin'" :fields="modules[index].fields" :chart="modules[index].chart" :datas="datas[index]" v-model="modules[index].trans_chart"  style="float:right"/>
                            </h3>
                            
                            <Chart  :marks="nMarks && nMarks.length>index && nMarks[index]" v-if="modules[index].no_chart!=true" :datas="modules[index].trans_chart?modules[index].trans_chart.data:datas[index]" :fields="modules[index].fields" :conf="modules[index].trans_chart?modules[index].trans_chart.config:modules[index].chart" :height="400"/>
                            <a-divider dashed style="margin:20px 0 10px 0" v-if="modules[index].no_chart!=true && modules[index].no_table!=true"/>
                            <h3 v-if="modules[index].no_table!=true">{{modules[index].no_chart==true?' ':modules[index].name}}
                                <a-button-group style="float:right; margin:0 0 10px 10px" >
                                    <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1'" :table="isMark(datas[index], m.fields)" :id="$route.query.id" /> -->
                                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                                    <a-button @click="exportToExcel(index)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                                    <a-button @click="copy(index)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                                </a-button-group>
                            </h3>
                            <div  class="page-block-info" v-html="getInfo(undefined, modules[index].infos, datas[index])" v-if="modules[index].infos && modules[index].infos.text"></div>
                            <!-- <div class="table-legend" v-if="isMark(datas[index], m.fields)"></div> -->
                            <DataTable v-if="modules[index].no_table!=true" :liucun="modules[index].liucun" :fields="modules[index].fields" :theads="modules[index].theads" 
                            :datas="datas[index]" :ref="`datatable_${index}`" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[index].xlen"
                            :small="modules[index].table && modules[index].table.size === 'small'"  :topscroll="config.topscroll" :show_index="modules[index].show_index"/>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import ChartTrans from '@/components/common/chart/chart_trans.vue'
import Mark from '@/components/common/chart/mark.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        Mark,
        ChartTrans,
    },
    computed: {
        nMarks() {
            const _marks = []
            if(this.datas.length) {
                this.datas.forEach(mod=>{
                    if(this.marks && this.marks.length >0 ){
                        _marks.push(this.marks)
                    }
                    else {
                        const _ms = []
                        if(mod instanceof Array) {
                            mod.forEach((row,ri)=>{
                                if(row['_mark'] || row['_mark2']) {
                                    _ms.push({
                                        'start_dt': row['ds'], 
                                        'end_dt': row['ds'], 
                                        'text': row['_mark'], 
                                        'tooltip': row['_mark'],
                                        'text2': row['_mark2']
                                    })
                                }
                            })
                        }
                        _marks.push(_ms)
                    }
                })
            }
            return _marks
        },
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.query(this.queryId, params).then((data)=>{
                this.datas = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    },
    data() {
        return {
            datas:[[]],
            current:0,
        }
    },
}
</script>